import { useSyncExternalStore } from 'react'

let pending = 0
const listeners = new Set<() => void>()

function emitChange() {
  for (const listener of listeners) {
    listener()
  }
}

export function beginNetworkActivity(): () => void {
  let ended = false
  const wasBusy = pending > 0

  pending += 1
  if (!wasBusy) {
    emitChange()
  }

  return () => {
    if (ended) {
      return
    }

    ended = true
    pending -= 1
    if (pending === 0) {
      emitChange()
    }
  }
}

export function subscribeNetworkActivity(listener: () => void) {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

export function getNetworkBusySnapshot() {
  return pending > 0
}

export function useIsNetworkBusy() {
  return useSyncExternalStore(
    subscribeNetworkActivity,
    getNetworkBusySnapshot,
    getNetworkBusySnapshot,
  )
}
